export default __webpack_public_path__ + "static/media/Edit Action Icon Component.ab0f27f8.svg";